module.exports = __webpack_public_path__ + "static/media/bankCheckmark.703191fc.svg";